import { gaEvent } from '@domgen/shared/services/ga/ga';
import { usePostHog } from '@posthog/react';
import { useLocation } from 'react-router-dom';
import { PhoneCircle } from '../assets/icons/PhoneCircle';
import { CALL_US_DESKTOP_LABEL, CALL_US_MOBILE_LABEL, CALL_US_TEL_HREF } from '../const/callUs';
import { PostHogEvent } from '../enums/postHogEvents';
import { capturePostHogEvent } from '../services/posthog/capture';
import { useAppState } from '../store/selectors/useAppState';
import { useUrlParams } from '../store/selectors/useUrlParams';
import { store } from '../store/store';
import { getGaPageName } from '../utils/ga/getGaPageName';
import { getSystemCode } from '../utils/getSystemCode';

const styles = {
  banner:
    'flex flex-row items-center justify-center gap-space-200 py-[5.5px] px-space-200 rounded-radius-100 bg-bg-primary whitespace-nowrap',
  icon: 'shrink-0 text-input-icon-selected',
  label: 'text-body-large-strong text-text-body [text-box:trim-both_cap_alphabetic]',
};

export const CallUsBanner = () => {
  const { session } = useAppState();
  const urlParams = useUrlParams();
  const systemCode = getSystemCode(urlParams?.rs);
  const posthog = usePostHog();
  const { pathname } = useLocation();
  const pagename = getGaPageName(pathname);

  const handleClick = () => {
    gaEvent({
      appSessionID: session?.id,
      event: 'genericGAEvent',
      eventCategory: 'appliance details form USA',
      eventAction: 'call-us-clicked',
      eventLabel: CALL_US_MOBILE_LABEL.toUpperCase(),
      pagename,
      category: 'registration-pages',
      type: 'STANDARD',
      regSystemCode: systemCode,
    });

    capturePostHogEvent(posthog, PostHogEvent.HEADER_CALL_US_CLICKED, store.get(), { pagename });
  };

  return (
    <div className={styles.banner}>
      <PhoneCircle className={styles.icon} />
      <a className={`desktop:hidden ${styles.label}`} href={CALL_US_TEL_HREF} onClick={handleClick}>
        {CALL_US_MOBILE_LABEL}
      </a>
      <span className={`hidden desktop:inline ${styles.label}`}>{CALL_US_DESKTOP_LABEL}</span>
    </div>
  );
};
